import { Button } from '../styles'
import { CancelButtonHook } from './CancelButton.hook'
import CancelConfirmationModal from '../CancelConfirmationModal'

const CancelButton = () => {
  const { handleCancel, isCreateMode, isModalOpen, handleModalConfirm, handleModalClose } =
    CancelButtonHook()

  return (
    <>
      <Button onClick={handleCancel}>ยกเลิก</Button>

      {isCreateMode && (
        <CancelConfirmationModal
          isModalOpen={isModalOpen}
          onClose={handleModalClose}
          onConfirm={handleModalConfirm}
        />
      )}
    </>
  )
}

export default CancelButton
